import React from 'react';
import { ShowIf } from 'components/utils';
import {msg} from "constants/message";
import {validatable} from 'components/utils';
import Select from 'react-select';

class DropDownMultipleSelect extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      value: this.props.value,
      isValid: true
    }
  }

  onChange(e) {
    this.setState({
      value: e
    });

    this.props.onChange(e);
  }

  validate() {
    if (this.state.value.length == 0 && this.props.require) {
      this.setState({
        isValid: false
      });
      this.select.focus();
      return false;
    } else {
      this.setState({
        isValid: true
      });
      return true;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value != nextProps.value) {
      this.setState({
        value: nextProps.value
      });
    }
    if (nextProps.value && nextProps.value.length > 0) {
      this.setState({
        isValid: true
      });
    }
  }

  classNames() {
    if (!this.state.isValid && this.state.value.length == 0) {
      return 'pt-multiple-danger';
    } else {
      return '';
    }
  }

  render() {
    return (
      <div className={this.props.className + ' mb18'}>
        <ShowIf condition={this.props.label != ''}>
          <label className="ip-label">
            { this.props.label }
            <ShowIf condition={this.props.require == true}>
              <span className="text-required">&nbsp;*</span>
            </ShowIf>
          </label>
        </ShowIf>
        <div name={this.props.name}>
          <Select
            className={this.classNames()}
            ref={(select) => {this.select = select}}
            value={this.state.value}
            options={this.props.options}
            isSearchable={this.props.isSearchable}
            onChange={this.onChange.bind(this)}
            placeholder='--Chọn--'
            multi={this.props.multi}
            joinValues
            noResultsText='Không có dữ liệu này'
            loadingPlaceholder ='Đang lấy dữ liệu...'
            disabled={this.props.disabled}
            isLoading={this.props.loading}
            closeMenuOnSelect={this.props.closeMenuOnSelect}
          />
        </div>

        <ShowIf condition={!this.state.isValid || !this.props.validLinhVucThanhTra}>
          <div className="pt-form-helper-text">{msg.messageDefault}</div>
        </ShowIf>
      </div>
      );
  }
}

DropDownMultipleSelect.defaultProps = {
  className: 'input-group',
  name: '',
  label: '',
  options: [],
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  value: [],
  keyName: 'key',
  valueName: 'value',
  require: false,
  multi: true,
  disabled: false,
  isSearchable: false,
  loading: false,
  closeMenuOnSelect: false,
  validLinhVucThanhTra: true
}

export default validatable(DropDownMultipleSelect);



// WEBPACK FOOTER //
// ./src/components/tt-forms/common/DropDownMultipleSelect.jsx